export default {
  newWindow: 'Åpnes i nytt vindu',
}
